@if(this.permanentsOperationsItems.length > 0){
    <ion-grid class="no_padding" >        
        <ion-row class="ion-align-items-center ion-justify-content-between"> 
            <ion-col class="title_card">
                {{'MY_PERMANENTS' | translate}}
                <marv-circle>{{this.permanentsOperationsItems.length}}</marv-circle>            
            </ion-col>                        
        </ion-row> 
    </ion-grid>

    <div id="permanents_operations_list">    
        @if(this.isFetching){
            <div class="bloc_loading">
                <ion-spinner></ion-spinner>
            </div>        
        }
        @else { 
            @for(permanentOperationItem of this.permanentsOperationsItems; track permanentOperationItem.id){
                <app-permanent-operation-item [permanentOperation]="permanentOperationItem"/>
            }            
        }
    </div>
}

